import type { QueryClient, QueryKey } from '@tanstack/react-query';

export interface IOptimisticWrite<TData> {
  previous?: TData;
  optimistic?: TData;
}

export const revertOptimisticWrite = <TData>(
  queryClient: QueryClient,
  queryKey: QueryKey,
  { previous, optimistic }: IOptimisticWrite<TData> = {},
): void => {
  if (previous === undefined || optimistic === undefined) return;
  if (queryClient.getQueryData<TData>(queryKey) !== optimistic) return;

  queryClient.setQueryData<TData>(queryKey, previous);
};
